import { render } from "./VtoHeader.vue?vue&type=template&id=3484b855"
import script from "./VtoHeader.vue?vue&type=script&lang=js"
export * from "./VtoHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__